module.exports = __webpack_public_path__ + "static/media/promo-10.773c73a3.png";